import { Navigate, useLocation } from 'react-router-dom';

/**
 * Redirects a retired path to its replacement while preserving the query string and the
 * hash (and any `:splat`-style suffix the caller bakes into `to`). Used for renamed pillars
 * like /settings/logins → /settings/sign-in-keys, /settings/members → /people/access
 * (steward-app#1921) and /settings/advisors → /people/advisors (steward-app#1922) so deep
 * links, filters and anchors survive. The advisors case is why the query is load-bearing:
 * prospects hold connect links minted as `/settings/advisors?advisor=<id>`, and
 * `routeGuards.test.tsx` pins the query and hash on that route.
 */
export function LegacyRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}
